import React from "react";

const HeroSection = () => {
  return (
    <section
      id="home"
      className="pt-24 pb-16 md:pt-32 md:pb-24 bg-blue-600 text-white"
    >
      <div className="container mx-auto px-4 text-center">
        <div className="flex flex-col items-center">
          <div className="mb-8">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
              Comfort for Every Season
            </h2>
            <p className="text-lg mb-8 text-blue-100 max-w-2xl mx-auto">
              Professional heating and cooling solutions for residential and
              commercial properties. Experienced technicians delivering quality
              service.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="#contact"
                className="bg-white text-blue-600 hover:bg-blue-50 font-medium py-3 px-6 rounded-lg text-center"
              >
                Get a Free Quote
              </a>
              <a
                href="#services"
                className="bg-transparent border-2 border-white hover:bg-white hover:text-blue-600 font-medium py-3 px-6 rounded-lg text-center transition duration-300"
              >
                Explore Services
              </a>
            </div>
          </div>
          <div className="w-full max-w-2xl">
            <img
              src="/api/placeholder/600/400"
              alt="HVAC Service"
              className="rounded-lg shadow-lg mx-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
